const CookiePolicy = () => {
    const nomeHost = process.env.REACT_APP_HOSTNOMECOMPLETO;
    const emailContatto = process.env.REACT_APP_EMAILCONTATTO;

    const sezioni = [
        {
            titolo: "1. Cosa Sono i Cookie?",
            contenuto: `I cookie sono piccoli file di testo che vengono salvati sul tuo dispositivo quando visiti un sito web. Servono a memorizzare informazioni utili, come le preferenze dell'utente o le sessioni di autenticazione. I cookie possono essere "di sessione" (vengono cancellati quando chiudi il browser) o "persistenti" (rimangono sul tuo dispositivo fino alla loro scadenza o cancellazione manuale).`,
        },
        {
            titolo: "2. Come Utilizziamo i Cookie?",
            contenuto: `Cookie Essenziali: Questi cookie sono necessari per il corretto funzionamento del sito. Ad esempio, vengono utilizzati per gestire la sessione dell'utente e garantire la sicurezza del sito. Senza questi cookie, il sito potrebbe non funzionare correttamente.`,
        },
        {
            titolo: "3. Cookie di Terze Parti",
            contenuto: `Attualmente, non utilizziamo cookie di terze parti per il tracciamento degli utenti o per scopi pubblicitari. Tuttavia, se in futuro dovessimo implementare tali funzionalità, aggiorneremo questa Cookie Policy e chiederemo il tuo consenso dove richiesto dalla legge.`,
        },
        {
            titolo: "4. Gestione dei Cookie",
            contenuto: `Puoi gestire le tue preferenze sui cookie direttamente dal tuo browser. La maggior parte dei browser consente di rifiutare o accettare i cookie, nonché di eliminare quelli già esistenti. Ti ricordiamo che disabilitare i cookie essenziali potrebbe compromettere il corretto funzionamento del sito.`,
            link: "https://www.allaboutcookies.org",
        },
        {
            titolo: "5. Modifiche alla Cookie Policy",
            contenuto: `Potremmo aggiornare questa Cookie Policy periodicamente per riflettere eventuali cambiamenti nella nostra gestione dei cookie. Qualsiasi modifica sarà pubblicata su questa pagina con un'indicazione della data di aggiornamento.`,
        },
        {
            titolo: "6. Contatti",
            contenuto: `Se hai domande o dubbi su questa Cookie Policy, puoi contattarci all'indirizzo email:`,
            email: emailContatto,
        },
    ];

    return (
        <div className="px-4 py-6">
            {/* Titolo Principale */}
            <h1 className="text-3xl font-bold text-center mb-6">Cookie Policy</h1>

            {/* Sezione Informazioni */}
            <div className="listingSection__wrap">
                {sezioni.map((sezione, index) => (
                    <div key={index} className="mb-6">
                        <h2 className="text-xl font-semibold mb-2">{sezione.titolo}</h2>
                        <p className="text-neutral-6000 dark:text-neutral-300">
                            {sezione.contenuto}
                        </p>
                        {sezione.link && (
                            <a
                                href={sezione.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 underline"
                            >
                                Visita il sito
                            </a>
                        )}
                        {sezione.email && (
                            <p className="text-neutral-6000 dark:text-neutral-300 font-bold">
                                {sezione.email}
                            </p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CookiePolicy;
